import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { LazyStyleInput } from './lazy-style.model';
import { LazyStylesService } from './lazy-styles.service';

@Directive({
  selector: '[cueLazyStyles]',
  standalone: true,
})
export class LazyStylesDirective implements OnInit {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private lazyStyles = inject(LazyStylesService);

  @Input({ alias: 'cueLazyStyles', required: true }) styles!: LazyStyleInput;

  async ngOnInit(): Promise<void> {
    await this.lazyStyles.loadMany(this.styles);
    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}
